import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-notes-dialog',
  templateUrl: './add-notes-dialog.component.html',
  standalone: false,
})
export class AddNotesDialogComponent {
  leadId: string;

  constructor(
    public dialogRef: MatDialogRef<AddNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: string;
    },
  ) {
    this.leadId = data.leadId;
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  btnSubmit_click() {
    this.dialogRef.close(true);
  }

  btnClose_click() {
    this.dialogRef.close(false);
  }
}
